import { render, staticRenderFns } from "./master.vue?vue&type=template&id=21b6c657&scoped=true"
import script from "./master.vue?vue&type=script&lang=js"
export * from "./master.vue?vue&type=script&lang=js"
import style0 from "./master.vue?vue&type=style&index=0&id=21b6c657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6c657",
  null
  
)

export default component.exports